import { createAsyncThunk } from '@reduxjs/toolkit'
import { UserAgent } from '../../../api/userAgent'

export const signIn = createAsyncThunk('user/account/sign-in', async ({ email, password }, thunkApi) => {
  try {
    const response = await UserAgent.signIn(email, password)

    return response
  } catch (error) {
    return thunkApi.rejectWithValue(error.response.data)
  }
})
